import React from "react";
import dayjs from "dayjs";
import { EFDatePill } from "./AgendaDatePill";

/* Shared agenda chrome for the Canchas and Beauty agendas. Styles are the `odcg-*` rules
   in reservas/components/OrganizerDailyCourtGrid.css (the importing screens load them). */

const DATE_FORMAT = "YYYY-MM-DD";

const Arrow = ({ points }) => (
	<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
		<polyline points={points} />
	</svg>
);

// Grilla / Tabla switch. `viewMode` is "grid" or "table".
export function AgendaViewTabs({ viewMode, onChange }) {
	return (
		<div className="odcg-view-tabs" role="tablist" aria-label="Vista de reservas">
			<button type="button" role="tab" aria-selected={viewMode === "grid"} className="zr-btn zr-btn--soft" onClick={() => onChange("grid")}>
				Grilla
			</button>
			<button type="button" role="tab" aria-selected={viewMode === "table"} className="zr-btn zr-btn--soft" onClick={() => onChange("table")}>
				Tabla
			</button>
		</div>
	);
}

// Hoy + day arrows + date pill, then the screen's actions (children), then the cancelled toggle.
// `date` and `onDateChange` use YYYY-MM-DD strings.
export default function AgendaToolbar({
	date,
	onDateChange,
	showCancelled,
	onShowCancelledChange,
	cancelledLabel,
	children,
}) {
	const shift = (days) => onDateChange(dayjs(date).add(days, "day").format(DATE_FORMAT));
	return (
		<div className="odcg-controls" aria-label="Controles de agenda">
			<div className="odcg-date-nav">
				<button type="button" className="odcg-btn-today" aria-label="Ir a hoy" onClick={() => onDateChange(dayjs().format(DATE_FORMAT))}>
					Hoy
				</button>
				<div className="odcg-nav-arrows">
					<button type="button" className="odcg-btn-arrow" aria-label="Día anterior" onClick={() => shift(-1)}>
						<Arrow points="15 18 9 12 15 6" />
					</button>
					<button type="button" className="odcg-btn-arrow" aria-label="Día siguiente" onClick={() => shift(1)}>
						<Arrow points="9 18 15 12 9 6" />
					</button>
				</div>
				<div className="odcg-date-control">
					<EFDatePill
						value={date}
						onChange={(d) => d && d.isValid() && onDateChange(d.format(DATE_FORMAT))}
						displayFormat="dddd D [de] MMMM"
						ariaLabel="Elegir fecha de agenda"
					/>
				</div>
			</div>
			{children}
			<label className="odcg-cancelled-toggle">
				<input type="checkbox" checked={showCancelled} onChange={(event) => onShowCancelledChange(event.target.checked)} />
				{cancelledLabel}
			</label>
		</div>
	);
}
